import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { Grid2 as Grid, IconButton, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReactHookFormDatePicker from "@components/ReactHookFormDatePicker/ReactHookFormDatePicker";
import CustomLabelInput from "@components/CustomLabelInput";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { PersonFormType } from "@utils/patientFormHelper";

const OccupationForm: FC<{
  index: number;
  form: UseFormReturn<PersonFormType>;
  onDeleteRow: (index: number) => void;
}> = ({
  form: {
    control,
    register,
    formState: { errors },
  },
  index,
  onDeleteRow,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6, md: 3 }}>
        <CustomLabelInput
          label={t("personForm.occupationNameInput.label")}
          id={`occupations-${index}-name`}
          required={true}
        >
          <TextField
            {...register(`occupations.${index}.name`, {
              required: true,
            })}
            error={!!errors?.occupations?.[index]?.name}
            id={`occupations-${index}-name`}
            type="text"
            size="small"
            variant="outlined"
            fullWidth
            placeholder={t("personForm.occupationNameInput.placeholder")}
          />
        </CustomLabelInput>
      </Grid>

      <Grid size={{ xs: 6, md: 4 }}>
        <CustomLabelInput
          label={t("personForm.occupationStartDateInput.label")}
          id={`occupations-${index}-startDate`}
        >
          <ReactHookFormDatePicker
            slotProps={{
              textField: {
                size: "small",
                error: !!errors?.occupations?.[index]?.startDate,
              },
            }}
            id={`occupations-${index}-startDate`}
            controller={{
              name: `occupations.${index}.startDate`,
              control,
              defaultValue: null,
            }}
          />
        </CustomLabelInput>
      </Grid>

      <Grid size={{ xs: 6, md: 4 }}>
        <CustomLabelInput
          label={t("personForm.occupationEndDateInput.label")}
          id={`occupations-${index}-endDate`}
        >
          <ReactHookFormDatePicker
            slotProps={{
              textField: {
                size: "small",
                error: !!errors?.occupations?.[index]?.endDate,
              },
            }}
            id={`occupations-${index}-endDate`}
            controller={{
              name: `occupations.${index}.endDate`,
              control,
              defaultValue: null,
            }}
          />
        </CustomLabelInput>
      </Grid>

      <Grid
        size={{ xs: 3, md: 1 }}
        display="flex"
        alignItems="flex-end"
        marginBottom="5px"
      >
        <IconButton
          color="error"
          size="small"
          onClick={() => onDeleteRow(index)}
        >
          <DeleteOutlineOutlinedIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default OccupationForm;
